/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  SettlementCompletedByTenantOptions,
  SettlementCompletedByTenantStatus200,
  SettlementCompletedByTenantStatus400,
  SettlementCompletedByTenantStatus401,
  SettlementCompletedByTenantStatus500,
} from '../types/SettlementCompletedByTenant'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { settlementCompletedByTenant } from '../clients/settlementCompletedByTenant'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const settlementCompletedByTenantMutationKey = () =>
  [{ url: '/v1/tenants/:tenant_id/settlements/complete' }] as const

export function settlementCompletedByTenantMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = settlementCompletedByTenantMutationKey()
  return mutationOptions<
    SettlementCompletedByTenantStatus200,
    ResponseErrorConfig<
      | SettlementCompletedByTenantStatus400
      | SettlementCompletedByTenantStatus401
      | SettlementCompletedByTenantStatus500
    >,
    SettlementCompletedByTenantOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, query }) => {
      return settlementCompletedByTenant({ ...config, path, query, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Settle the guarantee for a tenant.
 * {@link /v1/tenants/:tenant_id/settlements/complete}
 */
export function useSettlementCompletedByTenant<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SettlementCompletedByTenantStatus200,
      ResponseErrorConfig<
        | SettlementCompletedByTenantStatus400
        | SettlementCompletedByTenantStatus401
        | SettlementCompletedByTenantStatus500
      >,
      SettlementCompletedByTenantOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? settlementCompletedByTenantMutationKey()

  const baseOptions = settlementCompletedByTenantMutationOptions(config) as UseMutationOptions<
    SettlementCompletedByTenantStatus200,
    ResponseErrorConfig<
      | SettlementCompletedByTenantStatus400
      | SettlementCompletedByTenantStatus401
      | SettlementCompletedByTenantStatus500
    >,
    SettlementCompletedByTenantOptions,
    TContext
  >

  return useMutation<
    SettlementCompletedByTenantStatus200,
    ResponseErrorConfig<
      | SettlementCompletedByTenantStatus400
      | SettlementCompletedByTenantStatus401
      | SettlementCompletedByTenantStatus500
    >,
    SettlementCompletedByTenantOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    SettlementCompletedByTenantStatus200,
    ResponseErrorConfig<
      | SettlementCompletedByTenantStatus400
      | SettlementCompletedByTenantStatus401
      | SettlementCompletedByTenantStatus500
    >,
    SettlementCompletedByTenantOptions,
    TContext
  >
}
